import { connect } from 'react-redux';
import { compose } from 'redux';
import { setAnnouncement } from '~/components/Announcements/registry';
import RootStoreContext from '~/contexts/RootStoreContext';
import {
  actions as localStorageActions,
  selectors as localStorageSelectors
} from '~/domains/localStorage';
import { selectors as featureFlagsSelectors } from '~/domains/featureFlags';
import { OMNI_BANNER_ENABLED } from '~/domains/featureFlags/keys';
import OmniBanner from './OmniBanner';

const OMNI_BANNER_DISMISSED_KEY = 'isOmniBannerDismissed';

const condition = (state) => {
  const isFeatureFlagEnabled = featureFlagsSelectors.featureFlag(
    state,
    OMNI_BANNER_ENABLED
  );
  const isLocalStorageLoaded =
    localStorageSelectors.localStorageIsLoaded(state);
  const isBannerDismissed = localStorageSelectors.localStorageItem(
    state,
    OMNI_BANNER_DISMISSED_KEY
  );

  // Show banner if feature flag is enabled, localStorage is loaded and banner hasn't been dismissed
  return isFeatureFlagEnabled && isLocalStorageLoaded && !isBannerDismissed;
};

const mapDispatchToProps = (dispatch) => ({
  onClose: () =>
    dispatch(localStorageActions.setItem(OMNI_BANNER_DISMISSED_KEY, true))
});

export default compose(
  setAnnouncement(condition),
  connect(null, mapDispatchToProps, null, { context: RootStoreContext })
)(OmniBanner);
